// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__EXbcR","spinner1":"Spinner_spinner1__l6l10","slow":"Spinner_slow__PJ1fw","linear":"Spinner_linear__U4h0Q"};